// Environment configuration
const config = {
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
    WS_URL: process.env.REACT_APP_WS_URL || 'ws://localhost:8000/ws',
    getWebSocketUrl: (clientId) => {
        // Ensure clientId is properly encoded to prevent URL issues
        const encodedClientId = encodeURIComponent(String(clientId));
        return `${config.WS_URL}/${encodedClientId}`;
    }
};

export const { API_URL, WS_URL, getWebSocketUrl } = config;

export default config;
